import { createAction, createSlice } from '@reduxjs/toolkit';

export const providerAppointmentsSuccess = createAction(
  'providerAppointments/providerAppointmentsSuccess'
);

const providerAppointments = createSlice({
  name: 'providerAppointments',
  initialState: {
    isLoading: false,
    appointments: [],
    providerAppointmentsHash: null,
  },
  extraReducers: (builder) => {
    builder.addCase(providerAppointmentsSuccess, (state, action) => {
      const { data, hash } = action.payload;
      state.isLoading = false;
      if (hash !== state.providerAppointmentsHash) {
        state.appointments = data;
        state.providerAppointmentsHash = hash;
      }
    });
  },
  reducers: {
    providerAppointmentsRequest(state) {
      state.isLoading = true;
    },
    providerAppointmentsFailure(state) {
      state.isLoading = false;
    },
    updateSingleAppointment(state, { payload }) {
      const updatedAppointment = payload.data;
      const updatedAppointments = state.appointments.map((appt) => {
        if (appt.uuid === updatedAppointment.uuid) return updatedAppointment;
        return appt;
      });

      state.appointments = updatedAppointments;
    },
  },
});

const { actions, reducer } = providerAppointments;

export const {
  providerAppointmentsRequest,
  providerAppointmentsFailure,
  updateSingleAppointment,
} = actions;

export default reducer;
